export default function isValidCoupon(preferences: {
  cart?: {couponStatus?: {couponId?: string; errorMessage?: string}}
}) {
  return preferences?.cart?.couponStatus?.couponId && !preferences?.cart?.couponStatus?.errorMessage
}
